import { useMemo } from 'react';
import GeckoStore from 'services/gecko-store';

const GeckoFeatures = {
  can: (feature) => {
    const features = GeckoStore.redux.get('appState.features');
    const can = features[feature];
    if (can === true) {
      return true;
    }
    return false;
  },
};

export const useFeatureFlag = (featureName) => {
  const isFeatureEnabled = useMemo(() => {
    return GeckoFeatures.can(featureName);
  }, [featureName]);
  return isFeatureEnabled;
};

export default GeckoFeatures;
